/**
 * Generates a deterministic short ID from any string input using djb2 hash algorithm.
 *
 * @param input - The string to generate an ID from
 * @param length - The desired length of the generated ID (default: 8)
 * @returns A deterministic alphanumeric string of specified length
 *
 * @example
 * IdGenerator.generateShortId('my-group-name') // 'a1b2c3d4'
 * IdGenerator.generateShortId('document-key-group', 6) // 'x9y8z7'
 */
const generateShortId = (input: string, length: number = 8): string => {
  let hash = 5381;
  for (let i = 0; i < input.length; i++) {
    hash = ((hash << 5) + hash) + input.charCodeAt(i);
  }
  return Math.abs(hash).toString(36).substring(0, length);
};

export const IdGenerator = {
  generateShortId
} as const;